function allSwitchers() {
  const res = {
    sw_ev_converter: [
      { payload: 'ev', icon: 'mdi-cube' },
      { payload: 'ev_pot', icon: 'mdi-percent' }, // is converted using ev / pot formula
    ],
    sw_ev_icm_converter: [
      { payload: 'csd', icon: 'mdi-cube' },
      { payload: 'csd_pot', icon: 'mdi-percent' }, // is converted using ev / pot formula
      { payload: 'table_equity', icon: 'mdi-diamond' }, // is converted using tournament_evs_converter.table_equity
      { payload: 'dollar_ev', icon: 'mdi-currency-usd' }, // is converted using tournament_evs_converter.dollar_ev
    ],

    sw_rep_strategy: [{ payload: 'on' }, { payload: 'off' }],

    sw_rep_ev: [
      { payload: 'off' },
      { payload: 'hero' },
      { payload: 'opponent' },
      { payload: 'hero_opponent' },
    ],
    sw_rep_eq: [
      { payload: 'off' },
      { payload: 'hero' },
      { payload: 'opponent' },
      { payload: 'hero_opponent' },
    ],
    sw_rep_eqr: [
      { payload: 'off' },
      { payload: 'hero' },
      { payload: 'opponent' },
      { payload: 'hero_opponent' },
    ],
    sw_study_range_center: [{ payload: 'strategy' }, { payload: 'range' }],

    sw_study_strategy_fullscreen: [
      { payload: 'off', icon: 'mdi-fullscreen-exit' },
      { payload: 'on', icon: 'mdi-fullscreen' },
    ],
    sw_study_range_fullscreen: [
      { payload: 'off', icon: 'mdi-fullscreen-exit' },
      { payload: 'on', icon: 'mdi-fullscreen' },
    ],
    sw_study_breakdown_fullscreen: [
      { payload: 'off', icon: 'mdi-fullscreen-exit' },
      { payload: 'on', icon: 'mdi-fullscreen' },
    ],
    sw_study_reports_fullscreen: [
      { payload: 'off', icon: 'mdi-fullscreen-exit' },
      { payload: 'on', icon: 'mdi-fullscreen' },
    ],
    sw_tabs_study: [
      // query_soltab
      { payload: 'strategy' },
      { payload: 'range' },
      { payload: 'breakdown' },
      { payload: 'reports' },
    ],
    sw_tabs_strategy: [
      { payload: 'strategy' },
      { payload: 'strategy_ev' },
      { payload: 'strategy_eq', pw_prflop: true },
      { payload: 'ev' },
      { payload: 'ev_compare' },
      { payload: 'eq', pw_prflop: true },
      { payload: 'eqr', pw_prflop: true },
      { payload: 'overview_range' },
      { payload: 'overview_all' },
    ],
    sw_tabs_actions: [{ payload: 'actions' }, { payload: 'actions_chart' }],
    sw_tabs_actions_reports: [{ payload: 'actions' }, { payload: 'actions_chart' }],

    sw_tabs_tabletile: [
      { payload: 'poker_table_tile' },
      { payload: 'poker_table' },
      { payload: 'eq_chart' },
    ],

    sw_tabs_tabletile_icm_events: [
      { payload: 'poker_table_tile' },
      { payload: 'poker_table' },
      { payload: 'eq_chart' },
      { payload: 'stream_url' },
    ],

    sw_tabs_reports_tabletile: [
      { payload: 'poker_table_tile' }, //
      { payload: 'poker_table' },
    ],
    sw_tabs_reports: [
      { payload: 'cards' }, //
      { payload: 'filters' },
    ],
    sw_tabs_reports_all: [
      { payload: 'cards' },
      { payload: 'players' },
      { payload: 'actions' },
      { payload: 'actions_chart' },
      { payload: 'filters' },
    ],

    sw_tabs_handmatrix: [
      { payload: 'hands' },
      { payload: 'summary' },
      // { payload: 'breakdown' },
      { payload: 'filters', pw_prflop: true },
      { payload: 'blockers', pw_prflop: true },
    ],
    sw_tabs_handmatrix_all: [
      { payload: 'hands' },
      { payload: 'summary' },
      // { payload: 'breakdown' },
      { payload: 'filters', pw_prflop: true },
      { payload: 'actions' },
      { payload: 'actions_chart' },
      { payload: 'range_compare', pw_prflop: true },
      { payload: 'blockers', pw_prflop: true },
      { payload: 'eq_chart', pw_prflop: true },
      { payload: 'ev_compare' },
      // { payload: 'breakdown' },
    ],
    sw_tabs_handmatrix_icm_events: [
      { payload: 'hands' },
      { payload: 'summary' },
      { payload: 'filters', pw_prflop: true },
      { payload: 'blockers', pw_prflop: true },
    ],
    sw_tabs_handmatrix_all_icm_events: [
      { payload: 'hands' },
      { payload: 'summary' },
      { payload: 'filters', pw_prflop: true },
      { payload: 'actions' },
      { payload: 'actions_chart' },
      { payload: 'range_compare', pw_prflop: true },
      { payload: 'blockers', pw_prflop: true },
      { payload: 'eq_chart', pw_prflop: true },
      { payload: 'ev_compare' },
      { payload: 'stream_url' },
    ],
    sw_study_filter_intersection: [
      { payload: 'swv_filter_intersection', icon: 'mdi-vector-combine' }, //
      { payload: 'swv_filter_any', icon: 'mdi-vector-union' },
    ],
    sw_layout_study: [
      { payload: 'swv_layout_horizontal' },
      { payload: 'swv_layout_split' },
      { payload: 'swv_layout_horizontal_rvr' },
      { payload: 'swv_layout_split_rvr' },
    ],
    sw_layout_spacing_study: [
      { payload: 'swv_layout_spacing_large', iconGrid: 4 },
      { payload: 'swv_layout_spacing_medium', iconGrid: 6 },
      { payload: 'swv_layout_spacing_compact', iconGrid: 12 },
    ],

    sw_combos_columns: [
      { payload: 'swv_combos_vertical', icon: 'gw-icon-rangelength' },
      { payload: 'swv_combos_horizontal', icon: 'mdi-poll' },
    ],
    sw_combos_chart_style: [
      { payload: 'swv_combos_chart_line', icon: 'mdi-view-column' },
      { payload: 'swv_combos_chart_no_line', icon: 'mdi-square' },
    ],
    sw_range_height: [
      { payload: 'swv_range_normalized', icon: 'gw-icon-range-normalized' },
      { payload: 'swv_range_initial', icon: 'gw-icon-range-height' },
      { payload: 'swv_range_full', icon: 'gw-icon-range-fullheight' },
    ],
    sw_range_length: [
      { payload: 'swv_full_length', icon: 'gw-icon-range-fullheight' },
      { payload: 'swv_range_length', icon: 'gw-icon-rangelength' },
    ],
    sw_range_compare: [
      { payload: 'swv_eq_buckets_simple', isEQBucket: true },
      { payload: 'swv_eq_buckets_advanced', isEQBucket: true },
      { payload: 'swv_hands' },
      { payload: 'swv_draws' },
    ],
    sw_actions_grouping: [
      {
        payload: 'swv_grouping_none',
        icon: 'mdi-dots-grid',
        fn: ({ dispatch }) => {
          dispatch('resetColorSettings')
        },
      },
      {
        payload: 'swv_grouping_4',
        icon: 'mdi-view-grid',
        fn: ({ dispatch }) => {
          dispatch('resetColorSettings')
        },
      },
      {
        payload: 'swv_grouping_all',
        // icon: 'mdi-square',
        icon: 'gw-icon-actions-simple',
        fn: () => {
          const cssRaises = ['--clr-R1', '--clr-R2', '--clr-R3', '--clr-R4']
          cssRaises.forEach(cssVar => {
            document.documentElement.style.setProperty(cssVar, 'var(--clr-R_default)')
          })
        },
      },
    ],
    sw_trainer_result_chart: [
      { payload: 'swv_trainer_result_grid', icon: 'mdi-card' },
      { payload: 'swv_trainer_result_chart', icon: 'mdi-poll' },
    ],
    sw_range_content_hero: [
      { payload: 'swv_strategy' },
      { payload: 'swv_ev' },
      { payload: 'swv_eq', pw_prflop: true },
      { payload: 'swv_eqr', pw_prflop: true },
      { payload: 'swv_range' },
    ],
    sw_hand_content: [
      { payload: 'swv_overview_all' }, //
      { payload: 'swv_strategy' },
    ],
    sw_range_content_opponent: [
      { payload: 'swv_ev' },
      { payload: 'swv_eq', pw_prflop: true },
      { payload: 'swv_eqr', pw_prflop: true },
      { payload: 'swv_range' },
    ],
    sw_reports_flop_grouping: [
      { payload: 'swv_flops' },
      { payload: 'swv_high_cards' },
      { payload: 'swv_suits' },
      { payload: 'swv_pairing' },
      { payload: 'swv_connectedness' },
    ],
    sw_reports_turn_grouping: [
      { payload: 'swv_turns' },
      { payload: 'swv_suits' },
      { payload: 'swv_pairing' },
      { payload: 'swv_card_ranks' },
    ],

    sw_reports_flop_content: [
      { payload: 'swv_flop_chart', icon: 'mdi-poll' },
      { payload: 'swv_flop_table', icon: 'mdi-view-sequential' },
    ],
    sw_reports_turn_content: [
      { payload: 'swv_turn_cells', icon: 'mdi-view-grid' },
      { payload: 'swv_turn_chart', icon: 'mdi-poll' },
      { payload: 'swv_turn_table', icon: 'mdi-view-sequential' },
    ],
    sw_reports_colorcoding01: [
      { payload: 'swv_reports_colortext_colorchart', icon: 'mdi-chart-box' },
      { payload: 'swv_reports_colorchart', icon: 'mdi-chart-box' },
      { payload: 'swv_reports_colortext', icon: 'mdi-alpha' },
      { payload: 'swv_reports_colorcoded', icon: 'mdi-circle' },
      { payload: 'swv_reports_notcolorcoded', icon: 'mdi-circle-outline' },
    ],

    sw_combos_dialog_content: [
      { payload: 'swv_handmatrix', icon: 'mdi-view-grid' },
      { payload: 'swv_table_summary', icon: 'mdi-table' },
    ],
    sw_blockers_dialog_content: [
      { payload: 'swv_table_blockers', icon: 'mdi-table' },
      { payload: 'swv_table_all_summary', icon: 'mdi-cube' },
    ],
    sw_handmatrix: [
      { payload: 'swv_handmatrix_detailed', icon: 'mdi-numeric' },
      { payload: 'swv_handmatrix_simple', icon: 'mdi-numeric-off' },
    ],

    sw_rangebuilder_handmatrix: [
      { payload: 'hands' },
      { payload: 'summary' },
      { payload: 'filters' },
    ],

    sw_rangebuilder_handmatrix_all: [
      { payload: 'strategy' },
      { payload: 'hands' },
      { payload: 'summary' },
      { payload: 'filters' },
    ],
  }

  return res
}

export { allSwitchers }
